(function () {
  angular.module('binky.core.email-utils', ['binky.core.lodash', 'binky.core.src2-migration']);
})();
